import React from 'react';

const EmailLink = ({email}) => {
  const emailLink = `mailto:${email}`;
  return <a href={emailLink} className="email-link" target='_blank' rel="noopener noreferrer">{email}</a>;
}
export default EmailLink;
